module.exports = __webpack_public_path__ + "static/mou-min-770d071cda1d62877cc28fef2e906800.jpg";